__turbopack_context__.v({
  "accent-warm": "wrjwJq_accent-warm",
  "brand": "wrjwJq_brand",
  "figure": "wrjwJq_figure",
  "form-container": "wrjwJq_form-container",
  "hero": "wrjwJq_hero",
  "hero-content": "wrjwJq_hero-content",
  "hero-cta-group": "wrjwJq_hero-cta-group",
  "hero-video": "wrjwJq_hero-video",
  "lightblue": "wrjwJq_lightblue",
  "orange": "wrjwJq_orange",
  "pink": "wrjwJq_pink",
  "right": "wrjwJq_right",
  "simulation-form": "wrjwJq_simulation-form",
  "split-hero": "wrjwJq_split-hero",
  "subdued": "wrjwJq_subdued",
  "title": "wrjwJq_title",
  "transparent": "wrjwJq_transparent",
  "with-form": "wrjwJq_with-form",
  "yellow": "wrjwJq_yellow",
});
